import ApiService from './ApiService'

// User scoped lists
export const apiListRoles = () => ApiService.get('/user/list/roles')
export const apiListMachineTypes = () => ApiService.get('/user/list/machine-types')
export const apiListMachines = () => ApiService.get('/user/list/machines')
export const apiListTerms = () => ApiService.get('/user/list/terms')
export const apiListCustomers = () => ApiService.get('/user/list/customers')
export const apiListServiceStaffs = () => ApiService.get('/user/list/service-staffs')

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/user/permission-datas')
export const apiRolesList = data => ApiService.get('/user/roles', data)
export const apiRolesView = id => ApiService.get(`/user/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/user/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/user/roles/${id}/status`)

// Users
export const apiUsersList = data => ApiService.get('/user/users', data)
export const apiUsersView = id => ApiService.get(`/user/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/user/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/user/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/user/users/${id}/verified`)

// Customers
export const apiCustomersList = data => ApiService.get('/user/customers', data)
export const apiCustomersView = id => ApiService.get(`/user/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/user/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/user/customers/${id}/status`)
export const apiCustomersVerified = id => ApiService.post(`/user/customers/${id}/verified`)

// Service Staffs
export const apiServiceStaffsList = data => ApiService.get('/user/service-staffs', data)
export const apiServiceStaffsView = id => ApiService.get(`/user/service-staffs/${id}`)
export const apiServiceStaffsForm = (id, data) => ApiService.post(`/user/service-staffs${id ? `/${id}` : ''}`, data)
export const apiServiceStaffsStatus = id => ApiService.post(`/user/service-staffs/${id}/status`)
export const apiServiceStaffsVerified = id => ApiService.post(`/user/service-staffs/${id}/verified`)

// Stores
export const apiStoresList = data => ApiService.get('/user/stores', data)
export const apiStoresView = id => ApiService.get(`/user/stores/${id}`)
export const apiStoresForm = (id, data) => ApiService.post(`/user/stores${id ? `/${id}` : ''}`, data)
export const apiStoresStatus = id => ApiService.post(`/user/stores/${id}/status`)
export const apiStoresVerified = id => ApiService.post(`/user/stores/${id}/verified`)

// Order Requests
export const apiOrderRequestsList = data => ApiService.get('/user/order-requests', data)
export const apiOrderRequestsView = id => ApiService.get(`/user/order-requests/${id}`)
export const apiOrderRequestsStatus = (id, data) => ApiService.post(`/user/order-requests/${id}/status`, data)

// Orders
export const apiOrdersList = data => ApiService.get('/user/orders', data)
export const apiOrdersView = id => ApiService.get(`/user/orders/${id}`)
export const apiOrdersForm = (id, data) => ApiService.post(`/user/orders${id ? `/${id}` : ''}`, data)
export const apiOrdersHistories = (id, data) => ApiService.post(`/user/orders/${id}/histories`, data)
export const apiOrdersPayments = (id, data) => ApiService.post(`/user/orders/${id}/payments`, data)

// Order Progress
export const apiOrderProgressList = data => ApiService.get('/user/order-progress', data)
export const apiOrderProgressView = id => ApiService.get(`/user/order-progress/${id}`)
export const apiOrderProgressForm = data => ApiService.post('/user/order-progress', data)
export const apiOrderProgressStatus = (id, data) => ApiService.post(`/user/order-progress/${id}/status`, data)

export const apiOrderDeliveriesForm = data => ApiService.post(`/user/order-deliveries`, data)
export const apiOrderDeliveriesWarranty = (id, data) => ApiService.post(`/user/order-deliveries/${id}`, data)
export const apiOrderDeliveriesPDF = id => ApiService.blob(`/user/order-deliveries/${id}/pdf`)

// Warranty Services
export const apiWarrantyServicesList = data => ApiService.get('/user/warranty-services', data)
export const apiWarrantyServicesView = id => ApiService.get(`/user/warranty-services/${id}`)
export const apiWarrantyServicesUpdate = (id, data) => ApiService.post(`/user/warranty-services/${id}`, data)
export const apiWarrantyServicesStatus = (id, data) => ApiService.post(`/user/warranty-services/${id}/status`, data)
export const apiWarrantyServiceInspections = (id, machineId) =>
    ApiService.get(`/user/warranty-services/${id}/machines/${machineId}/inspections`)
export const apiWarrantyServiceInspectionsSubmit = (id, machineId, data) =>
    ApiService.post(`/user/warranty-services/${id}/machines/${machineId}/inspections`, data)
export const apiWarrantyServiceInspectionsPDF = (id, machineId) =>
    ApiService.get(`/user/warranty-services/${id}/machines/${machineId}/inspections/pdf`, undefined, { responseType: 'blob' })

// Customer Requests
export const apiCustomerRequestsList = data => ApiService.get('/user/customer-requests', data)
export const apiCustomerRequestsView = id => ApiService.get(`/user/customer-requests/${id}`)
export const apiCustomerRequestsStatus = (id, data) => ApiService.post(`/user/customer-requests/${id}/status`, data)

// Wallets
export const apiWalletsList = data => ApiService.get('/user/wallets', data)

// Withdrawal Requests
export const apiWithdrawalRequestsList = data => ApiService.get('/user/withdrawal-requests', data)
export const apiWithdrawalRequestsView = id => ApiService.get(`/user/withdrawal-requests/${id}`)
export const apiWithdrawalRequestsStatus = (id, data) => ApiService.post(`/user/withdrawal-requests/${id}/status`, data)

// Machine Types
export const apiMachineTypesList = data => ApiService.get('/user/machine-types', data)
export const apiMachineTypesView = id => ApiService.get(`/user/machine-types/${id}`)
export const apiMachineTypesForm = (id, data) => ApiService.post(`/user/machine-types${id ? `/${id}` : ''}`, data)
export const apiMachineTypesStatus = id => ApiService.post(`/user/machine-types/${id}/status`)

// Machines
export const apiMachinesList = data => ApiService.get('/user/machines', data)
export const apiMachinesView = id => ApiService.get(`/user/machines/${id}`)
export const apiMachinesForm = (id, data) => ApiService.post(`/user/machines${id ? `/${id}` : ''}`, data)
export const apiMachinesStatus = id => ApiService.post(`/user/machines/${id}/status`)

// Terms
export const apiTermsList = data => ApiService.get('/user/terms', data)
export const apiTermsView = id => ApiService.get(`/user/terms/${id}`)
export const apiTermsForm = (id, data) => ApiService.post(`/user/terms${id ? `/${id}` : ''}`, data)
export const apiTermsStatus = id => ApiService.post(`/user/terms/${id}/status`)

// Festival Offers
export const apiFestivalOffersList = data => ApiService.get('/user/festival-offers', data)
export const apiFestivalOffersView = id => ApiService.get(`/user/festival-offers/${id}`)
export const apiFestivalOffersForm = (id, data) => ApiService.post(`/user/festival-offers${id ? `/${id}` : ''}`, data)
export const apiFestivalOffersStatus = id => ApiService.post(`/user/festival-offers/${id}/status`)

// Service Inspections
export const apiServiceInspectionsList = data => ApiService.get('/user/service-inspections', data)
export const apiServiceInspectionsView = id => ApiService.get(`/user/service-inspections/${id}`)
export const apiServiceInspectionsForm = (id, data) => ApiService.post(`/user/service-inspections${id ? `/${id}` : ''}`, data)
export const apiServiceInspectionsStatus = id => ApiService.post(`/user/service-inspections/${id}/status`)

// Machine Demos
export const apiMachineDemosList = data => ApiService.get('/user/machine-demos', data)
export const apiMachineDemosView = id => ApiService.get(`/user/machine-demos/${id}`)
export const apiMachineDemosForm = (id, data) => ApiService.post(`/user/machine-demos${id ? `/${id}` : ''}`, data)
export const apiMachineDemosStatus = id => ApiService.post(`/user/machine-demos/${id}/status`)
